// auto created file
export const getResponsiveStyles = (screenSize, theme, language) => {
    const { isMobile, isTablet, isDesktop, isLargeDesktop } = screenSize;
    const isRTL = language === "ar";

    return {
      container: {
        // padding: isMobile ? "12px" : isTablet ? "16px" : "20px",
        // maxWidth: "100%",
        // margin: "0 auto",
        // width: "100%",
        // boxSizing: "border-box",
        marginTop: 10,
        direction: isRTL ? "rtl" : "ltr",
      },

      welcomeCard: {
        background:
          theme === "dark" ? "rgba(255,255,255,0.01)" : "rgba(255,255,255,1)",
        padding: isMobile ? "16px" : isTablet ? "20px" : "24px",
        borderRadius: isMobile ? "12px" : "16px",
        transition: "all 0.3s ease",
        boxShadow:
          theme === "dark"
            ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 8px 32px rgba(0,0,0,0.1)",
        backdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        WebkitBackdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        marginTop: -50,
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        marginBottom: isMobile ? "16px" : isTablet ? "20px" : "24px",
        cursor: "pointer",
      },

      welcomeSection: {
        marginBottom: 5,
      },

      welcomeTitle: {
        fontSize: isMobile
          ? "20px"
          : isTablet
            ? "24px"
            : isDesktop
              ? "28px"
              : "32px",
        fontWeight: "700",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        margin: "0 0 8px 0",
        textShadow:
          theme === "dark"
            ? "0 2px 4px rgba(0,0,0,0.3)"
            : "0 2px 4px rgba(0,0,0,0.1)",
        lineHeight: 1.2,
        textAlign: isRTL ? "right" : "left",
      },

      welcomeSubtitle: {
        fontSize: isMobile ? "14px" : isTablet ? "15px" : "16px",
        color:
          theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
        lineHeight: 1.5,
        textAlign: isRTL ? "right" : "left",
      },

      statsGrid: {
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : isTablet
            ? "repeat(2, 1fr)"
            : "repeat(4, 1fr)",
        gap: isMobile ? "12px" : isTablet ? "16px" : "20px",
        marginBottom: isMobile ? "16px" : isTablet ? "20px" : "24px",
      },

      statCard: {
        background:
          theme === "dark" ? "rgba(255,255,255,0.01)" : "rgba(255,255,255,1)",
        padding: isMobile ? "16px" : isTablet ? "18px" : "20px",
        borderRadius: isMobile ? "12px" : "16px",
        transition: "all 0.3s ease",
        boxShadow:
          theme === "dark"
            ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 8px 32px rgba(0,0,0,0.1)",
        backdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        WebkitBackdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
      },

      statHeader: {
        display: "flex",
        alignItems: "center",
        marginBottom: isMobile ? "8px" : "12px",
        flexDirection: isMobile ? "column" : "row",
        textAlign: isMobile ? "center" : isRTL ? "right" : "left",
        gap: isMobile ? "8px" : "0",
      },

      statIconWrapper: {
        width: isMobile ? "36px" : "40px",
        height: isMobile ? "36px" : "40px",
        borderRadius: isMobile ? "6px" : "8px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#fff",
        flexShrink: 0,
      },

      statTitle: {
        marginLeft: isMobile ? "0" : isRTL ? "0" : "12px",
        marginRight: isMobile ? "0" : isRTL ? "12px" : "0",
        fontSize: isMobile ? "12px" : "14px",
        color:
          theme === "dark" ? "rgba(255,255,255,0.9)" : "rgba(26,26,26,0.7)",
        fontWeight: "500",
        lineHeight: 1.3,
      },

      statValue: {
        fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
        fontWeight: "700",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        textAlign: isMobile ? "center" : isRTL ? "right" : "left",
        marginBottom: isMobile ? "4px" : "0",
      },

      statChange: {
        display: "flex",
        alignItems: "center",
        justifyContent: isMobile ? "center" : isRTL ? "flex-end" : "flex-start",
        gap: "6px",
        marginTop: "8px",
        color:
          theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.6)",
        fontSize: isMobile ? "12px" : "14px",
        flexWrap: "wrap",
        flexDirection: isRTL ? "row-reverse" : "row",
      },

      mainContent: {
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr" : "2fr 1fr",
        gap: isMobile ? "16px" : isTablet ? "20px" : "24px",
        alignItems: "start",
      },

      chartCard: {
        background:
          theme === "dark" ? "rgba(255,255,255,0.01)" : "rgba(255,255,255,1)",
        padding: isMobile ? "16px" : isTablet ? "20px" : "24px",
        borderRadius: isMobile ? "12px" : "16px",
        boxShadow:
          theme === "dark"
            ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 8px 32px rgba(0,0,0,0.1)",
        backdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        WebkitBackdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        cursor: "pointer",
        transition: "all 0.3s ease",
        order: isMobile ? 2 : 0,
        marginBottom: 40,
      },

      activityCard: {
        scrollbarWidth: "none", // للـ Firefox
        msOverflowStyle: "none", // للـ IE و Edge
        WebkitOverflowScrolling: "touch", // للـ iOS
        scrollbarWidth: "none", // للـ Firefox
        msOverflowStyle: "none", // للـ IE و Edge
        background:
          theme === "dark" ? "rgba(255,255,255,0.01)" : "rgba(255,255,255,1)",
        padding: isMobile ? "16px" : isTablet ? "20px" : "24px",
        borderRadius: isMobile ? "12px" : "16px",
        boxShadow:
          theme === "dark"
            ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 8px 32px rgba(0,0,0,0.1)",
        backdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        WebkitBackdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        cursor: "pointer",
        transition: "all 0.3s ease",
        order: isMobile ? 1 : 0,
      },

      cardTitle: {
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "6px" : "8px",
        marginBottom: isMobile ? "12px" : "16px",
        fontSize: isMobile ? "16px" : isTablet ? "17px" : "18px",
        fontWeight: "600",
        color: theme === "dark" ? "#fff" : "#1a1a1a",
        lineHeight: 1.3,
        flexDirection: isRTL ? "row" : "row",
        textAlign: isRTL ? "right" : "left",
      },

      chartContainer: {
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? "8px" : "12px",
      },

      chartBar: {
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "8px" : "12px",
        flexDirection: isMobile ? "column" : "row",
        textAlign: isMobile ? "center" : isRTL ? "right" : "left",
      },

      chartBarInfo: {
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "6px" : "8px",
        minWidth: isMobile ? "auto" : "120px",
        justifyContent: isMobile ? "center" : isRTL ? "flex-end" : "flex-start",
        flexDirection: isRTL ? "row-reverse" : "row",
      },

      chartBarColor: {
        width: isMobile ? "10px" : "12px",
        height: isMobile ? "10px" : "12px",
        borderRadius: "2px",
        flexShrink: 0,
      },

      chartBarLabel: {
        fontSize: isMobile ? "12px" : "14px",
        color: theme === "dark" ? "rgba(255,255,255,0.9)" : "#1a1a1a",
        fontWeight: "500",
      },

      chartBarProgress: {
        flex: 1,
        height: isMobile ? "6px" : "8px",
        background:
          theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
        borderRadius: isMobile ? "3px" : "4px",
        overflow: "hidden",
        minWidth: isMobile ? "200px" : "auto",
        direction: "ltr",
      },

      chartBarFill: {
        height: "100%",
        transition: "width 1s ease-in-out",
      },

      chartBarValue: {
        fontSize: isMobile ? "12px" : "14px",
        color: theme === "dark" ? "rgba(255,255,255,0.9)" : "#1a1a1a",
        minWidth: isMobile ? "auto" : "80px",
        textAlign: isMobile ? "center" : isRTL ? "left" : "right",
        fontWeight: "600",
      },

      chartSummary: {
        marginTop: isMobile ? "16px" : "20px",
        padding: isMobile ? "12px" : "16px",
        background:
          theme === "dark" ? "rgba(255,255,255,0.01)" : "rgba(0,0,0,0.03)",
        borderRadius: isMobile ? "8px" : "12px",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "center" : "center",
        gap: isMobile ? "8px" : "0",
        backdropFilter:
          theme === "dark" ? "blur(20px) saturate(150%)" : "blur(8px)",
        WebkitBackdropFilter:
          theme === "dark" ? "blur(20px) saturate(150%)" : "blur(8px)",
        border:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(0,0,0,0.05)",
        textAlign: isMobile ? "center" : isRTL ? "right" : "left",
      },

      chartSummaryText: {
        color:
          theme === "dark" ? "rgba(255,255,255,0.9)" : "rgba(26,26,26,0.7)",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: 1.4,
      },

      chartSummaryValue: {
        color: "#3b82f6",
        fontSize: isMobile ? "16px" : "18px",
        fontWeight: "700",
      },

      activityFeed: {
        maxHeight: isMobile ? "300px" : "400px",
        overflowY: "auto",
        paddingRight: isMobile ? "0" : isRTL ? "0" : "4px",
        paddingLeft: isMobile ? "0" : isRTL ? "4px" : "0",

        scrollbarWidth: "none", // للـ Firefox
        msOverflowStyle: "none", // للـ IE و Edge
        WebkitOverflowScrolling: "touch", // للـ iOS
        scrollbarWidth: "none", // للـ Firefox
        msOverflowStyle: "none", // للـ IE و Edge

      },

      activityItem: {
        display: "flex",
        alignItems: isMobile ? "flex-start" : "center",
        padding: isMobile ? "8px 0" : "12px 0",
        borderBottom:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(0,0,0,0.1)",
        gap: isMobile ? "8px" : "12px",
        flexDirection: isRTL ? "row-reverse" : "row",

      },

      activityIcon: {
        width: isMobile ? "28px" : "32px",
        height: isMobile ? "28px" : "32px",
        borderRadius: isMobile ? "6px" : "8px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
      },

      activityContent: {
        flex: 1,
        minWidth: 0,
        textAlign: isRTL ? "right" : "left",
      },

      activityText: {
        fontSize: isMobile ? "12px" : "14px",
        color: theme === "dark" ? "rgba(255,255,255,0.9)" : "#1a1a1a",
        lineHeight: 1.4,
        marginBottom: "2px",
        wordWrap: "break-word",
      },

      activityTime: {
        fontSize: isMobile ? "10px" : "12px",
        color:
          theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)",
        lineHeight: 1.3,
      },
    };
  };

export const getHoverStyles = (theme, screenSize) => ({
    transform: screenSize.isMobile ? "scale(1.02)" : "translateY(-5px)",
    boxShadow:
      theme === "dark"
        ? "0 12px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)"
        : "0 12px 40px rgba(0,0,0,0.15)",
    background:
      theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.95)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.2)"
        : "1px solid rgba(0,0,0,0.05)",
    backdropFilter:
      theme === "dark" ? "blur(30px) saturate(200%)" : "blur(15px)",
    WebkitBackdropFilter:
      theme === "dark" ? "blur(30px) saturate(200%)" : "blur(15px)",
  });

export const getDefaultStyles = (theme) => ({
    transform: "translateY(0) scale(1)",
    boxShadow:
      theme === "dark"
        ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
        : "0 8px 32px rgba(0,0,0,0.1)",
    background:
      theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.95)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.05)",
    backdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
    WebkitBackdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
  });

export const getStatIconBackground = (colorClass) => {
    const colorMap = {
      "bg-green-500": "#10b981",
      "bg-blue-500": "#2e7cba",
      "bg-purple-500": "#8b5cf6",
      "bg-yellow-500": "#f59e0b",
    };
    return colorMap[colorClass] || "#6b7280";
  };

export const getActivityIconStyle = (activityType) => {
    const activityColors = {
      employee: { background: "rgba(16,185,129,0.2)", color: "#10b981" },
      payroll: { background: "rgba(245,158,11,0.2)", color: "#f59e0b" },
      report: { background: "rgba(59,130,246,0.2)", color: "#3b82f6" },
      default: { background: "rgba(139,92,246,0.2)", color: "#8b5cf6" },
    };
    return activityColors[activityType] || activityColors.default;
  };